/** Placeholder blocks while a card loads, announced once as "Loading". */
export function LoadingBlock({ rows = 3, label = 'Loading' }: { rows?: number; label?: string }) {
  return (
    <div className="ci-loading" role="status">
      <span className="ci-visually-hidden">{label}…</span>
      {Array.from({ length: rows }, (_, index) => (
        <span key={index} className="ci-skeleton" aria-hidden="true" style={{ width: `${92 - index * 11}%` }} />
      ))}
    </div>
  )
}
